

// region JS Imports

// region External Modules
import u from "umbrellajs"
import Promise from "plugins/bluebird"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory,
  FollowButton,
} from "./factory"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--countries--follow-button"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`


interface Inputs {
  container?: string | HTMLElement
}
interface SafeInputs {
  container: string | HTMLElement
}

const DEFAULT_INPUTS: SafeInputs = {
  container: "body",
}


const init = (inputs: Inputs = {}) => {
  const inputs_with_defaults: SafeInputs = Object.assign({}, DEFAULT_INPUTS, inputs)

  return Promise.mapSeries(
    u(inputs_with_defaults.container).find(`.${CELL_CLASS_NAME}`).nodes,
    (el) => {
      if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
      el.classList.add(CELL_INITIALIZED_CLASS_NAME)

      return Factory.create({
        container: el,
      })
    },
  )
  .then((results) => {
    return results.filter<FollowButton>((element): element is FollowButton => {
      return element != null
    })
  })
}


export {
  init,
}
